import React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

type Props = { text: string };

function Label(props: Props & LabelPrimitive.LabelProps) {
  const { text, ...rest } = props;

  return (
    <LabelPrimitive.Root className='label' asChild {...rest}>
      {}
      <label>{text}</label>
    </LabelPrimitive.Root>
  );
}

export default Label;
